export enum DynamicUIDescriptionColumn {
  LEFT = "left",
  RIGHT = "right",
  CENTER = "center",
}
